import { GetServerSidePropsContext } from 'next'

import CardLists from '@/components/CardLists/CardLists'
import DefaultHead from '@/components/DefaultHead/DefaultHead'
import Main from '@/components/Main/Main'
import Panels from '@/components/Panels/Panels'
import Tabs from '@/components/Tabs/Tabs'
import { CommandersPageProps } from '@/types/page'
import { serverSidePropsFor } from '@/utils/helpers.server'

const PartnersSubPage = ({ data }: CommandersPageProps) => (
  <Main artCrop={data.container.json_dict.card.image_uris[0].art_crop}>
    <DefaultHead data={data} />
    <Panels data={data} />
    <Tabs />
    <CardLists disabledSortMethods={['percent', 'synergy']} initCardLists={data.container.json_dict.cardlists} />
  </Main>
)

export const getServerSideProps = async (context: GetServerSidePropsContext) =>
  serverSidePropsFor(`${process.env.NEXT_PUBLIC_EDHREC_JSON_URL}/pages/partners/${context.query.partner}.json`)

export default PartnersSubPage
